// Report type definitions
export const REPORT_TYPES = [
  {
    id: "income",
    title: "Income Report",
    description: "Revenue breakdown by month, client, and source",
    icon: "💰",
  },
  {
    id: "expense",
    title: "Expense Report",
    description: "Costs categorized by type and department",
    icon: "📉",
  },
  {
    id: "resource",
    title: "Resource Report",
    description: "Team hours, allocation, and utilization",
    icon: "👥",
  },
  {
    id: "yearly",
    title: "Yearly Summary",
    description: "Year-over-year comparison and trends",
    icon: "📅",
  },
  {
    id: "financial",
    title: "Financial Overview",
    description: "Profit & Loss summary with key metrics",
    icon: "📊",
  },
];

// Date range options
export const DATE_RANGES = [
  { id: "last_month", label: "Last Month" },
  { id: "last_quarter", label: "Last Quarter" },
  { id: "last_year", label: "Last Year" },
  { id: "custom", label: "Custom Range" },
];

// Mock report data generator
export function generateMockReportData(reportType, clientId, dateRange) {
  const baseData = {
    income: {
      summary: { total: 125000, growth: 12.5 },
      rows: [
        { month: "January", revenue: 28000, invoices: 12 },
        { month: "February", revenue: 32000, invoices: 15 },
        { month: "March", revenue: 35000, invoices: 18 },
        { month: "April", revenue: 30000, invoices: 14 },
      ],
      columns: ["Month", "Revenue (₹)", "Invoices"],
    },
    expense: {
      summary: { total: 78000, growth: -5.2 },
      rows: [
        { category: "Salaries", amount: 45000, percentage: 57.7 },
        { category: "Software", amount: 12000, percentage: 15.4 },
        { category: "Office", amount: 8000, percentage: 10.3 },
        { category: "Marketing", amount: 13000, percentage: 16.6 },
      ],
      columns: ["Category", "Amount (₹)", "% of Total"],
    },
    resource: {
      summary: { totalHours: 640, utilization: 85 },
      rows: [
        { resource: "Mayank", hours: 160, projects: 3, utilization: 90 },
        { resource: "Sumit", hours: 152, projects: 2, utilization: 85 },
        { resource: "Rahul", hours: 168, projects: 4, utilization: 95 },
        { resource: "Neha", hours: 160, projects: 3, utilization: 75 },
      ],
      columns: ["Resource", "Hours", "Projects", "Utilization %"],
    },
    yearly: {
      summary: { currentYear: 450000, lastYear: 380000, growth: 18.4 },
      rows: [
        { metric: "Total Revenue", current: 450000, previous: 380000, change: "+18.4%" },
        { metric: "Total Expenses", current: 280000, previous: 260000, change: "+7.7%" },
        { metric: "Net Profit", current: 170000, previous: 120000, change: "+41.6%" },
        { metric: "Clients Served", current: 24, previous: 18, change: "+33.3%" },
      ],
      columns: ["Metric", "Current Year", "Previous Year", "Change"],
    },
    financial: {
      summary: { revenue: 450000, profit: 170000, margin: 37.8 },
      rows: [
        { item: "Gross Revenue", amount: 450000 },
        { item: "Cost of Services", amount: 180000 },
        { item: "Gross Profit", amount: 270000 },
        { item: "Operating Expenses", amount: 100000 },
        { item: "Net Profit", amount: 170000 },
      ],
      columns: ["Item", "Amount (₹)"],
    },
  };

  return baseData[reportType] || baseData.income;
}
